<div class="inputTitle" *ngIf="label">
  <span>{{label}}<i MatSuffix matTooltip={{tooltipName}} matTooltipPosition="right" [matTooltipHideDelay]="delay"
      id="i1" class="flaticon-message" *ngIf="tooltipIcon"></i></span>
</div>

<div class="btn" [hidden]="!isEditable">
  <mat-button-toggle-group [class.has-errors]="errors?.length" [id]="name" [(ngModel)]="data" [name]="name"
    [disabled]="disabled">
    <mat-button-toggle *ngFor="let i of options" [value]="i" [class.active]="isEqualObj(data, i)">
      {{getDisplay(i)}}
    </mat-button-toggle>
  </mat-button-toggle-group>
</div>

<div class="viewLable" *ngIf="!isEditable">
  <span>{{getDisplay(_data)}}</span>
</div>

<ul *ngIf="errors?.length" class="errorList">
  <li *ngFor="let item of errors" class="error">{{item}}</li>
</ul>